module.exports = __webpack_public_path__ + "img/suyatsu_modal.a9309091.png";